import 'arrive';
import $ from 'jquery';
import 'waypoints/lib/noframework.waypoints.min.js';

document.arrive('.steps .focus', {existing: true}, function(){

    var $block = $(this);

    var blockOffsetTop = $block[0].offsetTop;

    checkBlockViewOffset();

    $(window).on('scroll', checkBlockViewOffset);

    function checkBlockViewOffset(event) {

        var percentage = ((blockOffsetTop) / $(window).scrollTop()) - 1;

        if(percentage < 0.7 ){
            $block.addClass('scrolled');
        }
    }

});